export default function createCareNoteMock({ resolve }) {
	setTimeout(() => {
		resolve();
	}, 1000);
}
